import React from 'react';
import PropTypes from 'prop-types';

function ChatPause({ size = 40, className, style, onClick }) {
  return (
    <svg className={className} style={style} onClick={onClick} width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="4" fill="#3A3A3C"/>
      <path d="M17.8083 12H13.9995V28H17.8083V12Z" fill="#88898B"/>
      <path d="M25.8088 12H22V28H25.8088V12Z" fill="#88898B"/>
    </svg>
  )
}

ChatPause.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
}

export default ChatPause;
